import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/set-d2c.png'
import _imports_1 from '@/assets/image/set-b2b.png'


const _withScopeId = n => (_pushScopeId("data-v-0a592a57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-search" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { style: {"color":"#52C41A"} }
const _hoisted_8 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_0,
  style: {"margin-left":"30px"},
  class: "order-tag"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  referrerPolicy: "no-referrer",
  src: _imports_1,
  style: {"margin-left":"30px"},
  class: "order-tag"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { style: {"color":"#52C41A"} }

import { isD2C, useRtfix, useSite } from '@/store'
import { t } from '@/plugins/i18n'
import { ref, Ref, toRaw, computed, nextTick, onActivated, onDeactivated } from 'vue'
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router'
import { useStore } from 'vuex'
import STable from '@/components/Table/index.vue'
import GoodsLink from '@/components/common/GoodsLink.vue'
import AppLink from '@/components/common/AppLink.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import CombinationDialog from '../components/CombinationDialog.vue'
import ProductStats from '../components/ProductStats.vue'
import SSearch from './Search.vue'
import { getPlatformOrderItemSearch } from '@/apis/order'
import { childColumns, tableConfig, childConfig } from './data'
import { setNoEmptyForm, isEqualObj } from '@/util/common'
import { channelEnum, productStatsEnum, combinationStatusDict, setProdcutLink } from '../data'
import ProductSku from '../components/ProductSku.vue'
import { cloneDeep } from 'lodash'
import DrawerDocumentaryRecord from '../components/DrawerDocumentaryRecord.vue'
import DocumentaryRecord from '../components/DocumentaryRecord.vue'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onBeforeRouteUpdate((to) => {
  const { query } = to
  const params = { ...query }
  if (params.productSkuList) {
    params.productSkuList = params.productSkuList.split(',')
  }
  if (params.customerProductMskuList) {
    params.customerProductMskuList = params.customerProductMskuList?.split(',')
  }
  setForm(params, () => refreshTable(true))
})

onActivated(() => {
  const { query } = useRoute()
  isBatchSearch.value = false
  const params = { ...query }
  if (params.productSkuList) {
    params.productSkuList = params.productSkuList.split(',')
  }
  if (params.customerProductMskuList) {
    params.customerProductMskuList = params.customerProductMskuList?.split(',')
  }
  if (query.productSkuList) {
    batchSearchParams.value = {
      customerShopId,
      productSkuList: query.productSkuList && query.productSkuList.split(',')
    }
  }
  if (query.customerProductMskuList && query.customerProductMskuList.indexOf(',') > -1) {
    batchSearchParams.value = {
      customerShopId,
      customerProductMskuList: query.customerProductMskuList && query.customerProductMskuList.split(',')
    }
    isBatchSearch.value = true
  }
  setForm(params, () => refreshTable(true))
})

onDeactivated(() => {
  orderForm.value = {}
})
const imgHeader = 'https://static-s.theckb.com/BusinessMarket/Client/fund/split-'
const pageData = ref({
  page: 1,
  limit: 30
})

const store = useStore()
const customerShopId = store.getters.curShop
let sourceForm = {}
const orderForm: Ref<any> = ref({})
const setForm = (form: any, fn?: any) => {
  orderForm.value = { ...form }
  if (!orderForm.value.customerProductMskuList || (typeof orderForm.value.customerProductMskuList !== 'string' && orderForm.value.customerProductMskuList.length > 1)) {
    orderForm.value.customerProductMskuList = ''
  }
  sourceForm = { ...form }
  fn && fn()
}
const router = useRouter()
const route = useRoute()
const { query } = useRoute()
setForm(query)

const filterData = computed(() => {
  return {
    ...setNoEmptyForm(cloneDeep(toRaw(orderForm.value))),
    customerShopId
  }
})

const drawerDocumentaryRecordRef = ref()
const openExpress = (info: any, row: any, status: number) => {
  drawerDocumentaryRecordRef.value.open({
    info: info,
    row,
    status
  })
}

const combinationVisible = ref(false)
const rowItem = ref({})
const openCombinationVisible = (row: any) => {
  rowItem.value = toRaw(row)
  combinationVisible.value = true
}

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}

const toggleExpandAllChange = () => {
  nextTick(() => {
    STableRef.value.expandAllChange()
  })
}

const refresh = () => {
  const comparisonForm = setNoEmptyForm(cloneDeep(toRaw(orderForm.value)))
  // 搜索之后把批量搜索条件删除
  delete comparisonForm.productSkuList
  delete comparisonForm.customerProductMskuList
  if (isEqualObj(sourceForm, comparisonForm)) {
    refreshTable(true)
  } else {
    const query = {
      ...setNoEmptyForm(comparisonForm),
      customerProductMskuList: orderForm.value?.customerProductMskuList && orderForm.value?.customerProductMskuList?.join(',')
    }
    if (orderForm.value?.customerProductMskuList) {
      query.customerProductMskuList = orderForm.value?.customerProductMskuList && orderForm.value?.customerProductMskuList?.join(',')
    }
    router.replace({
      query
    })
  }
}
const batchSearchParams = ref({})
const isBatchSearch = ref(!!route.query.productSkuList || !!route.query.customerProductMskuList) // 是否批量搜索
if (route.query.productSkuList) {
  batchSearchParams.value = {
    customerShopId,
    productSkuList: route.query.productSkuList && route.query.productSkuList.split(',')
  }
}
if (route.query.customerProductMskuList) {
  batchSearchParams.value = {
    customerShopId,
    customerProductMskuList: route.query.customerProductMskuList && route.query.customerProductMskuList.split(',')
  }
}
const search = () => {
  isBatchSearch.value = false
  refresh()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SSearch, {
      form: orderForm.value,
      "onUpdate:form": _cache[0] || (_cache[0] = ($event: any) => ((orderForm).value = $event)),
      onRefresh: search
    }, null, 8, ["form"]),
    _createVNode(STable, {
      ref: (_value, _refs) => {
        _refs['STableRef'] = _value
        STableRef.value = _value
      },
      class: "productTable",
      "page-data": pageData.value,
      "onUpdate:page-data": _cache[1] || (_cache[1] = ($event: any) => ((pageData).value = $event)),
      api: _unref(getPlatformOrderItemSearch),
      filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
      columns: _unref(childColumns),
      tableConfig: _unref(tableConfig),
      isImmediatelyExec: false,
      onDataListener: _cache[2] || (_cache[2] = ($event: any) => (toggleExpandAllChange()))
    }, {
      expand: _withCtx(({ scope }) => [
        _createVNode(STable, {
          class: "combinationTable",
          "table-data": scope.row.combinationOrderItemList,
          columns: _unref(childColumns),
          tableConfig: _unref(childConfig),
          showPagination: false
        }, {
          settleStatus: _withCtx(({ row }) => [
            (row.virtualFlag)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " - "))
              : ([1, 2].includes(row.settleStatus))
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('未结算')), 1))
                : (row.settleStatus === 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)('已结算')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
          ]),
          platformOrderNo: _withCtx(({ row }) => [
            (row.platformOrderId)
              ? (_openBlock(), _createBlock(AppLink, {
                  key: 0,
                  to: _unref(useRtfix)('OrderInfo', { params: { id: row.platformOrderId } })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.platformOrderNo), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row.platformOrderNo), 1))
          ]),
          orderItemStatus: _withCtx(({ row }) => [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(productStatsEnum)[row.orderItemStatus]), 1)
          ]),
          shoppingInfo: _withCtx(({ row }) => [
            _createVNode(ShoppingPreview, {
              image: row.productSkuImg || row.productMainImg || '',
              name: row.productTitleJp || '',
              url: _unref(setProdcutLink)(row)
            }, null, 8, ["image", "name", "url"]),
            (row.productType === 3 && _unref(isD2C)())
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : _createCommentVNode("", true),
            (row.priorityShippingStatus && _unref(isD2C)())
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  referrerPolicy: "no-referrer",
                  src: `${imgHeader}d2c-${_unref(useSite)()}.png`,
                  style: {"margin-left":"30px"},
                  class: "order-tag"
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true),
            (row.productType === 3 && !_unref(isD2C)())
              ? (_openBlock(), _createElementBlock("img", _hoisted_10))
              : _createCommentVNode("", true),
            (row.priorityShippingStatus && !_unref(isD2C)())
              ? (_openBlock(), _createElementBlock("img", {
                  key: 3,
                  referrerPolicy: "no-referrer",
                  src: `${imgHeader}b2b-${_unref(useSite)()}.png`,
                  style: {"margin-left":"30px"},
                  class: "order-tag"
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          productSku: _withCtx(({ row }) => [
            row
              ? (_openBlock(), _createBlock(ProductSku, {
                  key: 0,
                  row: row
                }, null, 8, ["row"]))
              : _createCommentVNode("", true)
          ]),
          channel: _withCtx(({ row }) => [
            (row.productType === 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(t)('组合')), 1)
                ], 64))
              : (row.productType === 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)('OEM')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(_unref(channelEnum)[row.channel] || '-'), 1)
                  ], 64))
          ]),
          shoppingStats: _withCtx(({ row }) => [
            row
              ? (_openBlock(), _createBlock(DocumentaryRecord, {
                  key: 0,
                  row: row,
                  showExpress: true,
                  onOpen: openExpress
                }, null, 8, ["row"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["table-data", "columns", "tableConfig"])
      ]),
      settleStatus: _withCtx(({ row }) => [
        (row.virtualFlag)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, " - "))
          : ([1, 2].includes(row.settleStatus))
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(t)('未结算')), 1))
            : (row.settleStatus === 3)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(t)('已结算')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
      ]),
      platformOrderNo: _withCtx(({ row }) => [
        (row.platformOrderId)
          ? (_openBlock(), _createBlock(AppLink, {
              key: 0,
              to: _unref(useRtfix)('OrderInfo', { params: { id: row.platformOrderId } })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.platformOrderNo), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(row.platformOrderNo), 1))
      ]),
      customerOrderNoHead: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref(isD2C)() ? _unref(t)('客户订单编号') : _unref(t)('订单标题')), 1)
      ]),
      orderItemStatus: _withCtx(({ row }) => [
        _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(productStatsEnum)[row.orderItemStatus]), 1)
      ]),
      shoppingInfo: _withCtx(({ row }) => [
        _createVNode(ShoppingPreview, {
          image: row.productSkuImg || row.productMainImg || '',
          name: row.productTitleJp || '',
          url: _unref(setProdcutLink)(row)
        }, null, 8, ["image", "name", "url"])
      ]),
      productSku: _withCtx(({ row }) => [
        row
          ? (_openBlock(), _createBlock(ProductSku, {
              key: 0,
              row: row
            }, null, 8, ["row"]))
          : _createCommentVNode("", true)
      ]),
      channel: _withCtx(({ row }) => [
        (row.productType === 3)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(t)('组合')), 1)
            ], 64))
          : (row.productType === 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_unref(t)('OEM')), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(_unref(channelEnum)[row.channel] || '-'), 1)
              ], 64))
      ]),
      shoppingStats: _withCtx(({ row }) => [
        (row.productType === 3)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "text",
              onClick: ($event: any) => (openCombinationVisible(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(combinationStatusDict)[row.combinationStatus]), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              row
                ? (_openBlock(), _createBlock(DocumentaryRecord, {
                    key: 0,
                    row: row,
                    showExpress: true,
                    onOpen: openExpress
                  }, null, 8, ["row"]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      actualProductSellPrice: _withCtx(({ row }) => [
        _createElementVNode("div", null, _toDisplayString(row.actualProductSellPrice) + " " + _toDisplayString(_unref(showCurrentUnit)(row.goodsCountry === _unref(COUNTRY).KR)), 1)
      ]),
      actualTotalProductSellPrice: _withCtx(({ row }) => [
        _createElementVNode("div", null, _toDisplayString(row.actualTotalProductSellPrice) + " " + _toDisplayString(_unref(showCurrentUnit)(row.goodsCountry === _unref(COUNTRY).KR)), 1)
      ]),
      _: 1
    }, 8, ["page-data", "api", "filterData", "columns", "tableConfig"]),
    _createVNode(CombinationDialog, {
      visible: combinationVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((combinationVisible).value = $event)),
      rowItem: rowItem.value
    }, null, 8, ["visible", "rowItem"]),
    _createVNode(DrawerDocumentaryRecord, {
      ref: (_value, _refs) => {
        _refs['drawerDocumentaryRecordRef'] = _value
        drawerDocumentaryRecordRef.value = _value
      }
    }, null, 512)
  ]))
}
}

})